import React from 'react';
import heroImage from '../../../images/runningmanmarquee-blue.jpg';

const VisitorMessagePanel = () => {

  const brandMessageColor = 'white';
  const brandTextColor = '#c4c4c4';

  return (
    <div className='browser-signin-messaging' >
      <div className='super'> Welcome to the Era of</div>
      <div className='headline'>Screenless<br/>Productivity</div>
      <div className='sub'>Convert any document to <br />audio and be productive anywhere</div>
      <div className='processes'>
        LISTEN <i className='fa fa-chevron-right brandColor24' style={{marginRight: 12, marginLeft: 8}}/>
        HIGHLIGHT <i className='fa fa-chevron-right brandColor24' style={{marginRight: 12, marginLeft: 8}}/>
        COMMENT  <i className='fa fa-chevron-right brandColor24' style={{marginRight: 12, marginLeft: 8}}/>
        COLLABORATE
      </div>
    </div>
  )
}

export default VisitorMessagePanel;
